export default __webpack_public_path__ + "static/media/Imagen_Error.c8f59047.svg";